// frontend/src/pages/TerminosPage.js
import React from 'react';
import { useNavigate } from 'react-router-dom';
import Footer from '../components/Footer';

const TerminosPage = () => {
    const navigate = useNavigate();

    const sectionStyle = { marginBottom: '2rem' };
    const titleStyle = { fontSize: '1.25rem', fontWeight: 700, color: '#1e293b', marginBottom: '0.75rem' };
    const textStyle = { color: '#475569', lineHeight: 1.8, fontSize: '0.95rem' };

    return (
        <div style={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
            <style>{`
                .pub-nav-tabs { position: absolute; left: 50%; transform: translateX(-50%); display: flex; align-items: center; gap: 0.25rem; }
                .pub-nav-title { display: inline; }
                .pub-nav-login-text { display: inline; }
                .pub-nav-login-icon { display: none; }
                @media (max-width: 640px) {
                    .pub-nav-tabs { position: static; transform: none; left: auto; }
                    .pub-nav-title { display: none; }
                    .pub-nav-mobile-title { display: inline !important; }
                    .pub-nav-login-text { display: none; }
                    .pub-nav-login-icon { display: inline; }
                }
            `}</style>

            <nav style={{
                position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1100, height: '70px',
                background: 'var(--primary)',
                boxShadow: 'var(--shadow-md)',
                display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '0 1.5rem',
            }}>
                <button onClick={() => navigate('/')} style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'white', fontWeight: 600, fontSize: '1.15rem', fontFamily: "'Inter','Segoe UI',sans-serif", display: 'flex', alignItems: 'center', gap: '0.6rem', padding: 0, flexShrink: 0 }}>
                    <span className="pub-nav-title">Estudio Jurídico Previsional</span>
                    <span className="pub-nav-mobile-title" style={{ display: 'none' }}>GestiónEJP</span>
                </button>
                <div className="pub-nav-tabs">
                    <button onClick={() => navigate('/')} style={{ background: 'none', border: 'none', borderBottom: '2px solid transparent', padding: '0.5rem 1rem', fontSize: '0.9rem', fontWeight: 400, color: 'rgba(255,255,255,0.75)', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.4rem', whiteSpace: 'nowrap', height: '70px' }} onMouseEnter={(e) => { e.currentTarget.style.color = 'white'; }} onMouseLeave={(e) => { e.currentTarget.style.color = 'rgba(255,255,255,0.75)'; }}>
                        <i className="bi bi-house-door"></i> Inicio
                    </button>
                    <button onClick={() => navigate('/', { state: { seccion: 'nosotros' } })} style={{ background: 'none', border: 'none', borderBottom: '2px solid transparent', padding: '0.5rem 1rem', fontSize: '0.9rem', fontWeight: 400, color: 'rgba(255,255,255,0.75)', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.4rem', whiteSpace: 'nowrap', height: '70px' }} onMouseEnter={(e) => { e.currentTarget.style.color = 'white'; }} onMouseLeave={(e) => { e.currentTarget.style.color = 'rgba(255,255,255,0.75)'; }}>
                        <i className="bi bi-info-circle"></i> Sobre Nosotros
                    </button>
                </div>
                <button onClick={() => navigate('/login')} style={{ background: 'rgba(255,255,255,0.15)', border: '1.5px solid rgba(255,255,255,0.6)', borderRadius: '8px', padding: '0.45rem 1.1rem', color: 'white', fontWeight: 600, fontSize: '0.9rem', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '0.5rem', flexShrink: 0 }} onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.3)'; }} onMouseLeave={(e) => { e.currentTarget.style.background = 'rgba(255,255,255,0.15)'; }}>
                    <i className="bi bi-box-arrow-in-right pub-nav-login-icon"></i>
                    <span className="pub-nav-login-text">Iniciar Sesión</span>
                </button>
            </nav>

            <div style={{ flex: 1, maxWidth: '800px', margin: '0 auto', width: '100%', boxSizing: 'border-box', padding: '1.5rem', paddingTop: '86px', paddingBottom: '3rem' }}>
                <h1 style={{ fontSize: '2rem', fontWeight: 800, color: '#0f172a', marginBottom: '0.5rem' }}>Términos de Uso</h1>
                <p style={{ color: '#64748b', marginBottom: '2.5rem', fontSize: '0.9rem' }}>Última actualización: Febrero 2026</p>

                <div style={sectionStyle}>
                    <h2 style={titleStyle}>1. Aceptación de los Términos</h2>
                    <p style={textStyle}>Al acceder y utilizar la plataforma GestiónEJP, el usuario acepta estos términos de uso en su totalidad. Este sistema es propiedad del <strong>Estudio Jurídico Previsional</strong> y su uso está reservado exclusivamente al personal autorizado del estudio.</p>
                </div>
                <div style={sectionStyle}>
                    <h2 style={titleStyle}>2. Acceso al Sistema</h2>
                    <p style={textStyle}>El acceso a GestiónEJP requiere credenciales de usuario proporcionadas y validadas por la administración del estudio. Cada usuario es responsable de:</p>
                    <ul style={{ ...textStyle, paddingLeft: '1.5rem' }}>
                        <li>Mantener la confidencialidad de sus credenciales de acceso.</li>
                        <li>No compartir su cuenta con terceros.</li>
                        <li>Notificar inmediatamente cualquier uso no autorizado de su cuenta.</li>
                        <li>Utilizar el sistema exclusivamente para fines laborales autorizados.</li>
                    </ul>
                </div>
                <div style={sectionStyle}>
                    <h2 style={titleStyle}>3. Uso Adecuado</h2>
                    <p style={textStyle}>El usuario se compromete a utilizar la plataforma de manera responsable y conforme a la legislación vigente. Queda prohibido:</p>
                    <ul style={{ ...textStyle, paddingLeft: '1.5rem' }}>
                        <li>Acceder a datos o funcionalidades no autorizadas para su rol.</li>
                        <li>Extraer, copiar o distribuir información de clientes fuera del ámbito profesional.</li>
                        <li>Intentar vulnerar las medidas de seguridad del sistema.</li>
                        <li>Utilizar el sistema para fines distintos a la gestión de trámites del estudio.</li>
                    </ul>
                </div>
                <div style={sectionStyle}>
                    <h2 style={titleStyle}>4. Confidencialidad</h2>
                    <p style={textStyle}>Toda la información contenida en el sistema es de carácter <strong>estrictamente confidencial</strong>. Los datos de los clientes del estudio están protegidos por el secreto profesional y la Ley N° 25.326 de Protección de Datos Personales.</p>
                </div>
                <div style={sectionStyle}>
                    <h2 style={titleStyle}>5. Propiedad Intelectual</h2>
                    <p style={textStyle}>La plataforma GestiónEJP, incluyendo su diseño, código, funcionalidades y componentes tecnológicos, es desarrollada y mantenida por el equipo GestiónEJP. Queda prohibida su reproducción, distribución o modificación sin autorización expresa del titular de los derechos.</p>
                </div>
                <div style={sectionStyle}>
                    <h2 style={titleStyle}>6. Limitación de Responsabilidad</h2>
                    <p style={textStyle}>Se realizarán esfuerzos razonables para mantener la disponibilidad del sistema. No obstante, el funcionamiento puede verse afectado por factores técnicos o causas ajenas al control razonable del proveedor tecnológico.</p>
                </div>
                <div style={sectionStyle}>
                    <h2 style={titleStyle}>7. Contacto</h2>
                    <p style={textStyle}>Para consultas sobre estos términos de uso, puede comunicarse a: <strong>contacto.gestionejp@gmail.com</strong></p>
                </div>
            </div>

            <Footer />
        </div>
    );
};

export default TerminosPage;

